import { render, staticRenderFns } from "./TableCopy.vue?vue&type=template&id=5922988c&scoped=true"
import script from "./TableCopy.vue?vue&type=script&lang=js"
export * from "./TableCopy.vue?vue&type=script&lang=js"
import style0 from "./TableCopy.vue?vue&type=style&index=0&id=5922988c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5922988c",
  null
  
)

export default component.exports